import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FiMessageCircle } from 'react-icons/fi';
import { gameAPI } from '../../services/api';
import { useTelegram } from '../../hooks/useTelegram';

const Page = styled.div`
  min-height: 100vh;
  background: #0a0a0f;
  padding: 16px;
  padding-bottom: 90px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 4px;
`;

const Sub = styled.p`
  color: rgba(255,255,255,0.4);
  font-size: 13px;
  margin-bottom: 20px;
`;

const TabRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
`;

const Tab = styled.button`
  flex: 1;
  padding: 10px 12px;
  border-radius: 12px;
  border: 2px solid ${p => p.$active ? '#107C10' : 'rgba(255,255,255,0.1)'};
  background: ${p => p.$active ? 'rgba(16,124,16,0.15)' : 'rgba(255,255,255,0.03)'};
  color: ${p => p.$active ? '#4CD964' : 'rgba(255,255,255,0.5)'};
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
`;

const Card = styled.a`
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 14px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  text-decoration: none;
  transition: all 0.15s;
  &:active { transform: scale(0.98); }
`;

const CardLeft = styled.div``;

const CardTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
`;

const CardSub = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #006FFF;
`;

const CardPrice = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #4CD964;
`;

const ORDER_URL = 'https://t.me/openps_support';

const GamePass = () => {
  const navigate = useNavigate();
  const { tg, hapticFeedback } = useTelegram();
  const [tab, setTab] = useState('own');
  const [items, setItems] = useState([]);

  useEffect(() => {
    const goBack = () => navigate('/xbox');
    if (tg) { tg.setHeaderColor('#0a0a0f'); tg.BackButton.show(); tg.BackButton.onClick(goBack); }
    gameAPI.getDonates().then(setItems).catch(() => {});
    return () => { if (tg) { tg.BackButton.offClick(goBack); tg.BackButton.hide(); } };
  }, [tg, navigate]);

  const subtype = tab === 'own' ? 'xbox_gamepass_own' : 'xbox_gamepass_new';
  const filtered = items
    .filter(i => i.subtype === subtype)
    .sort((a, b) => a.price_rub - b.price_rub);

  return (
    <Page>
      <Title>🟢 Xbox GamePass Ultimate</Title>
      <Sub>Подписка на 500+ игр для Xbox и PC</Sub>

      <TabRow>
        <Tab $active={tab === 'own'} onClick={() => { setTab('own'); hapticFeedback?.('light'); }}>
          На ваш аккаунт
        </Tab>
        <Tab $active={tab === 'new'} onClick={() => { setTab('new'); hapticFeedback?.('light'); }}>
          На новый аккаунт
        </Tab>
      </TabRow>

      {filtered.map(item => {
        const label = item.title.replace('GamePass Ultimate ', '').replace(/\(.*\)/, '').trim();
        return (
          <Card key={item.id} href={ORDER_URL} target="_blank" onClick={() => hapticFeedback?.('light')}>
            <CardLeft>
              <CardTitle>{label}</CardTitle>
              <CardSub><FiMessageCircle size={11} /> Заказать</CardSub>
            </CardLeft>
            <CardPrice>{item.price_rub.toLocaleString('ru')} ₽</CardPrice>
          </Card>
        );
      })}
    </Page>
  );
};

export default GamePass;
